export default __webpack_public_path__ + "static/media/icon-heart-outline.dce97f29.svg";